import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeService {
  msPerMinute = 60 * 1000;
  msPerHour = this.msPerMinute * 60;
  msPerDay = this.msPerHour * 24;
  msPerMonth = this.msPerDay * 30;
  msPerYear = this.msPerDay * 365;

  constructor() { }

  getTimeAgo(previous: Date): string {
    const epochTime = new Date(previous).getTime();
    const now = Date.now();
    const elapsed = now - epochTime;

    if (!epochTime)
      return 'Never';
    if (elapsed < this.msPerMinute)
      return 'Just now';
    else if (elapsed < this.msPerHour)
      return Math.round(elapsed / this.msPerMinute) + ' mins ago';
    else if (elapsed < this.msPerDay)
      return Math.round(elapsed / this.msPerHour) + ' hours ago';
    else if (elapsed < this.msPerMonth)
      return Math.round(elapsed / this.msPerDay) + ' days ago';
    else if (elapsed < this.msPerYear)
      return Math.round(elapsed / this.msPerMonth) + ' months ago';
    else
      return Math.round(elapsed / this.msPerYear) + ' years ago';
  }

  isRecent(previous: Date): boolean {
    const epochTime = new Date(previous).getTime();
    const now = Date.now();
    const elapsed = now - epochTime;

    if (!elapsed)
      return false;

    return elapsed < this.msPerDay;
  }

}
